/**
 * Given data in the shape of { a: [1, 2], b: ['x', 'y'] }, (nicknamed "array shape"),
 * it "transposes" them to [{ a: 1, b: 'x' }, { a: 2, b: 'y'}].
 *
 * Used to parse data from api calls that return the data in "array shape".
 * If no data is found, it returns an empty array.
 */
export const transposeArrayType = <T>(arrayType: ArrayType<T>): T[] => {
  const keys = Object.keys(arrayType) as (keyof ArrayType<T>)[]

  const firstRow = arrayType[keys[0]]
  if (!firstRow) {
    return []
  }

  const length = firstRow.length

  const objects: T[] = []

  for (let index = 0; index < length; index++) {
    const entries = keys.map(key => [key, arrayType[key][index]])
    objects.push(Object.fromEntries(entries))
  }

  return objects
}

interface ApiObject<T> {
  [key: string]: T[]
}

export const reverseTransposeArrayType = <T>(apiObject: { [key: string]: T }[]): { [key: string]: T[] } => {
  const newObject = Object.keys(apiObject[0]).reduce<ApiObject<T>>((prev, curr) => {
    if (!prev[curr]) return { ...prev, [curr]: [] }
    return prev
  }, {})

  apiObject.forEach(object => {
    Object.keys(object).forEach(item => newObject[item]?.push(object[item]))
  })

  return newObject
}
